import React, { memo } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { useRegisterFormHeaderStyles } from './RegisterFormHeader.styles';

export const RegisterFormHeader = memo(() => {
    const { t } = useTranslation();
    const { container } = useRegisterFormHeaderStyles();

    return (
        <Grid className={container} data-signa="auth-register-form-header-container">
            <Typography data-signa="auth-register-form-header-text1" variant="h5">
                {t('auth.register_form_heder.start_trial_account')}
            </Typography>
            <Typography data-signa="auth-register-form-header-text2" variant="h6">
                {t('auth.register_form_heder.is_not_necessary_credit_card')}
            </Typography>
        </Grid>
    );
});
